<template>
	<div class="ol-layerswitcher weather-toolbar ol-unselectable ol-control" style="height: auto;">
		<button type="button" @click.stop.prevent="show_panel = !show_panel"></button>
		<div class='panel px-2' :class="{ closed: !show_panel, open: show_panel }">
			<div class="form-check my-2">
				<input class="form-check-input" type="checkbox" value="" id="weather-control-temp" v-model='temperature'>
				<label class="form-check-label ml-2" for="weather-control-temp">
					Temperatures (text)
				</label>
			</div>

			<div class="form-check my-2">
				<input class="form-check-input" type="checkbox" value="" id="weather-control-wind-speed" v-model="wind_speed">
				<label class="form-check-label ml-2" for="weather-control-wind-speed">
					Wind Speeds (text)
				</label>
			</div>

			<div class="form-check my-2">
				<input class="form-check-input" type="checkbox" value="" id="weather-control-wind-gusts" v-model="wind_gusts">
				<label class="form-check-label ml-2" for="weather-control-wind-gusts">
					Wind Gusts
				</label>
			</div>

			<div class="form-check my-2">
				<input class="form-check-input" type="checkbox" value="" id="weather-control-lightning" v-model="lightning">
				<label class="form-check-label ml-2" for="weather-control-lightning">
					Lightning Strikes
				</label>
			</div>

			<div class="form-check my-2">
				<input class="form-check-input" type="checkbox" value="" id="weather-control-humidity" v-model="humidity">
				<label class="form-check-label ml-2" for="weather-control-humidity">
					Humidity
				</label>
			</div>

			<div class="form-check my-2">
				<input class="form-check-input" type="checkbox" value="" id="weather-control-precipitation" v-model="precipitation">
				<label class="form-check-label ml-2" for="weather-control-precipitation">
					Precipitation
				</label>
			</div>

			<div class="form-check my-2">
				<input class="form-check-input" type="checkbox" value="" id="weather-control-alerts" v-model='alerts'>
				<label class="form-check-label ml-2" for="weather-control-alerts">
					Alerts (Severe)
				</label>
			</div>
		</div>
	</div>

</template>



<script>
	import {mapState} from 'vuex'
	import AerisWeather from '@aerisweather/javascript-sdk';


	export default {
		name: 'WeatherToolbar',
		data () {
			return {
				aeris: null,
				panel_status: 'closed',
				weather_map: null,
				show_panel: false,
				temperature: false,
				alerts: false,
				humidity: false,
				precipitation: false,
				wind_speed: false,
				wind_gusts: false,
				lightning: false
			}
		},
		watch: {
			temperature() {
				this.showTemperatures();
			},
			alerts() {
				this.showAlerts();
			},
			humidity() {
				this.showHumidity();
			},
			precipitation() { this.showPrecipitation() },
			wind_speed() { this.showWindSpeed() },
			wind_gusts() { this.showWindGusts() },
			lightning() { this.showLightning() }
		},
		computed: {
			map() { return this.$store.state.map.map; },
			layers() { return this.$store.state.map.layers; },
			location() { return this.$store.state.location; }
		},
		mounted() {
			this.aeris = new AerisWeather(this.$config.weather.access_id, this.$config.weather.secret_key);
			this.aeris.views().then((views) => {
				this.weather_map = new views.InteractiveMap(this.map);
			})
		},
		methods: {
			showAlerts() {
				if (!this.alerts) {
					this.weather_map.removeLayer('alerts');
					return;
				}

				this.weather_map.addLayer('alerts:50', {
					category: 'severe',
				});
			},
			showHumidity() {
				if (!this.humidity) {
					this.weather_map.removeLayer('humidity');
					return;
				}

				this.weather_map.addLayer('humidity:50')
			},
			showWindSpeed() {
				if (!this.wind_speed) {
					this.weather_map.removeLayer('wind-speeds-text');
					return;
				}

				this.weather_map.addLayer('wind-speeds-text');
			},
			showWindGusts() {
				if (!this.wind_gusts) {
					this.weather_map.removeLayer('wind-gusts');
					return;
				}

				this.weather_map.addLayer('wind-gusts:50');
			},
			showPrecipitation() {
				if (!this.precipitation) {
					this.weather_map.removeLayer('precip');
					return;
				}

				this.weather_map.addLayer('precip:50');
			},
			showLightning() {
				if (!this.lightning) {
					this.weather_map.removeLayer('lightning-strikes');
					return;
				}

				this.weather_map.addLayer('lightning-strikes:50');
			},
			showTemperatures() {
				if (!this.temperature) {
					this.weather_map.removeLayer('temperatures-text');
					return;
				}

				this.weather_map.addLayer('temperatures-text');

				// this.weather_map.addLayer('observations', {
				// 	request: this.aeris.api().endpoint('observations').place(this.location.lat+ ','+ this.location.long),
				// 	data: {
				// 		properties: {
				// 			timestamp: 'periods.ob.timestamp',
				// 			value: 'periods.ob.tempF'
				// 		}
				// 	}
				// });

			}
		}
	}
</script>
